import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import {userGuard} from "../guards/user.guard";

export const routes: Routes = [
    { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    {
        path: 'login',
        loadChildren: () =>
            import('./login/login.module').then((login) => login.LoginModule),
    },
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivateChild: [userGuard],
        loadChildren: () =>
            import('./dashboard/dashboard.module').then((dashboard) => dashboard.DashboardModule),
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule { }
